<template>
  <Card class="oauth-redirect-urls-list" :is-loading="loading">
    <ElTable
      dir="ltr"
      class="oauth-redirect-urls-list__table"
      :data="redirectUrls"
      stripe
      row-key="id"
    >
      <ElTableColumn
        prop="url"
        align="left"
        :label="$t('APP.OAUTH.REDIRECT_URLS.SINGLE_REDIRECT_URL')"
      />
      <ElTableColumn width="100" align="center">
        <template slot-scope="{ row: redirectUrl }">
          <DeleteWithConfirm
            :message="$t('DELETE_ITEM_WARNING')"
            :delete-function="() => deleteRedirectUrl(redirectUrl)"
          />
        </template>
      </ElTableColumn>
    </ElTable>
  </Card>
</template>

<script>
import DeleteWithConfirm from '@@/common/action-buttons/DeleteWithConfirm';
import Card from '@@/common/Card';

export default {
  name: 'OAuthRedirectUrlsList',
  components: {
    DeleteWithConfirm,
    Card,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    redirectUrls: {
      type: Array,
      required: true,
    },
  },
  methods: {
    deleteRedirectUrl(redirectUrl) {
      this.$emit('delete-redirect-url', redirectUrl);
    },
  },
};
</script>

<style lang="scss">
.oauth-redirect-urls-list {
  &__table {
    margin-top: $global-margin;
  }
}
</style>
